import { NbiDimensions } from "../../common/generic/generic-nbi-dimensions";
import { NBIKpis } from "../../common/generic/generic-nbi-domains";

const portfolioClientId = "Portfolio Client Id";
const portfolioClientName = "Portfolio Client Name";
const coriGroupId = "GLBA client group ID";
const coriGroupName = "GLBA client group name";
const clientSubGroupId = "Client Sub Group Id";
const clientSubGroup = "Client Sub Group";
const clientLegalEntityId = "Client Legal Entity Id";
const clientLegalEntity = "Client Legal Entity";
const portfolioClientCountry = "Portfolio Client Country";
const originatingEntity = "Originating Entity";
const clientRCTforLegalEntity = "Client RCT for Legal Entity";

const dealCreditDate = "Deal credit Date";
const oECountry = "OE Country";
const productLevel1 = "Product Level 1";
const productLevel2 = "Product Level 2";
const productLevel3 = "Product Level 3";
const primaryObligorName = "Primary Obligor Name";
const bookingPlace = "Booking Place";

export function getDefaultAttributes(): [
  { field: string; headerName: string }
] {
  const attrs = new NbiDimensions();
  const portfolioAttributes: any = [];
  portfolioAttributes.push(
    { field: attrs.DIM_DEAL_CODE, headerName: "Deal Code" },
    { field: attrs.CALENDAR_DATE, headerName: dealCreditDate },
    { field: attrs.CALENDAR_MONTH_LABEL, headerName: "Month" },
    { field: attrs.YEAR, headerName: "Year" },
    { field: attrs.CLIENT_GEN_ID, headerName: portfolioClientId },
    { field: attrs.CLIENT_GEN_NAME, headerName: portfolioClientName },
    { field: attrs.CLIENT_CORIGRPCOMID, headerName: coriGroupId },
    { field: attrs.CLIENT_CORIGRPNAME, headerName: coriGroupName },
    { field: attrs.SUB_GRP_ID, headerName: clientSubGroupId },
    { field: attrs.SUB_GRP_FULL_NAME, headerName: clientSubGroup },
    { field: attrs.LE_ID, headerName: clientLegalEntityId },
    { field: attrs.CLIENT_LENAME, headerName: clientLegalEntity },
    {
      field: attrs.CLIENT_GEN_COM_CTRY_LABEL,
      headerName: portfolioClientCountry,
    },
    {
      field: attrs.CLIENT_LE_RCT_CODE,
      headerName: clientRCTforLegalEntity,
    },
    { field: attrs.EC_ID, headerName: "EC Id" },
    { field: attrs.EC_FULL_NAME, headerName: "EC Name" },
    { field: attrs.FPV_BL, headerName: "BL" },
    { field: attrs.FPV_SBL, headerName: "SBL" },
    { field: attrs.FPV_SSBL, headerName: "SSBL" },
    { field: attrs.SALES_TEAM_NAME, headerName: "Sales Team name" },
    { field: attrs.SALES, headerName: "Sales" },
    { field: attrs.OE_SHORT_LABEL, headerName: originatingEntity },
    { field: attrs.OE_RES_CTRY_NAME, headerName: oECountry },
    { field: attrs.PRODUCT_LEVEL1, headerName: productLevel1 },
    { field: attrs.PRODUCT_LEVEL2, headerName: productLevel2 },
    { field: attrs.PRODUCT_LEVEL3, headerName: productLevel3 },
    { field: attrs.IS_IB, headerName: "IB/Non IB" },
    { field: attrs.PO_LEFULLNAME, headerName: primaryObligorName },
    { field: attrs.SALESBEN_SALES_LOCATION, headerName: "Sales Location" },
    { field: attrs.BOOKING_PLACE, headerName: bookingPlace }
  );
  return portfolioAttributes;
}

export function getNbiRwaAttributes(): [{ field: string; headerName: string }] {
  const attrs = new NbiDimensions();
  const portfolioAttributes: any = [];
  portfolioAttributes.push(
    { field: attrs.DIM_DEAL_CODE, headerName: "Deal Code" },
    { field: attrs.CALENDAR_DATE, headerName: dealCreditDate },
    { field: attrs.YEAR, headerName: "Year" },
    { field: attrs.CLIENT_GEN_ID, headerName: portfolioClientId },
    { field: attrs.CLIENT_GEN_NAME, headerName: portfolioClientName },
    { field: attrs.CLIENT_CORIGRPCOMID, headerName: coriGroupId },
    { field: attrs.CLIENT_CORIGRPNAME, headerName: coriGroupName },
    { field: attrs.SUB_GRP_ID, headerName: clientSubGroupId },
    { field: attrs.SUB_GRP_FULL_NAME, headerName: clientSubGroup },
    { field: attrs.LE_ID, headerName: clientLegalEntityId },
    { field: attrs.CLIENT_LENAME, headerName: clientLegalEntity },
    {
      field: attrs.CLIENT_GEN_COM_CTRY_LABEL,
      headerName: portfolioClientCountry,
    },
    {
      field: attrs.CLIENT_LE_RCT_CODE,
      headerName: clientRCTforLegalEntity,
    },
    { field: attrs.EC_ID, headerName: "EC Id" },
    { field: attrs.EC_FULL_NAME, headerName: "EC Name" },
    { field: attrs.FPV_BL, headerName: "BL" },
    { field: attrs.FPV_SBL, headerName: "SBL" },
    { field: attrs.FPV_SSBL, headerName: "SSBL" },
    { field: attrs.OE_SHORT_LABEL, headerName: originatingEntity },
    { field: attrs.OE_RES_CTRY_NAME, headerName: oECountry },
    { field: attrs.PRODUCT_LEVEL1, headerName: productLevel1 },
    { field: attrs.PRODUCT_LEVEL2, headerName: productLevel2 },
    { field: attrs.PRODUCT_LEVEL3, headerName: productLevel3 },
    { field: attrs.IS_IB, headerName: "IB/Non IB" },
    { field: attrs.PO_LEFULLNAME, headerName: primaryObligorName },
    { field: attrs.BOOKING_PLACE, headerName: bookingPlace }
  );
  return portfolioAttributes;
}
export function getRwaAttributes(): [{ field: string; headerName: string }] {
  const attrs = new NbiDimensions();
  const portfolioAttributes: any = [];
  portfolioAttributes.push(
    { field: attrs.DIM_DEAL_CODE, headerName: "Deal Code" },
    { field: attrs.RWA_CLOSE_OFF_DATE, headerName: dealCreditDate },
    { field: attrs.YEAR, headerName: "Year" },
    { field: attrs.CLIENT_GEN_ID, headerName: portfolioClientId },
    { field: attrs.CLIENT_GEN_NAME, headerName: portfolioClientName },
    { field: attrs.CLIENT_CORIGRPCOMID, headerName: coriGroupId },
    { field: attrs.CLIENT_CORIGRPNAME, headerName: coriGroupName },
    { field: attrs.SUB_GRP_ID, headerName: clientSubGroupId },
    { field: attrs.SUB_GRP_FULL_NAME, headerName: clientSubGroup },
    { field: attrs.LE_ID, headerName: clientLegalEntityId },
    { field: attrs.CLIENT_LENAME, headerName: clientLegalEntity },
    {
      field: attrs.CLIENT_GEN_COM_CTRY_LABEL,
      headerName: portfolioClientCountry,
    },
    {
      field: attrs.CLIENT_LE_RCT_CODE,
      headerName: clientRCTforLegalEntity,
    },
    { field: attrs.EC_ID, headerName: "EC Id" },
    { field: attrs.EC_FULL_NAME, headerName: "EC Name" },
    { field: attrs.FPV_BL, headerName: "BL" },
    { field: attrs.FPV_SBL, headerName: "SBL" },
    { field: attrs.FPV_SSBL, headerName: "SSBL" },
    { field: attrs.OE_SHORT_LABEL, headerName: originatingEntity },
    { field: attrs.OE_RES_CTRY_NAME, headerName: oECountry },
    { field: attrs.PRODUCT_LEVEL1, headerName: productLevel1 },
    { field: attrs.PRODUCT_LEVEL2, headerName: productLevel2 },
    { field: attrs.PRODUCT_LEVEL3, headerName: productLevel3 },
    { field: attrs.IS_IB, headerName: "IB/Non IB" },
    { field: attrs.PO_LEFULLNAME, headerName: primaryObligorName },
    { field: attrs.BOOKING_PLACE, headerName: bookingPlace }
  );
  return portfolioAttributes;
}
export function getDefaultKpis(): [{ field: string; headerName: string }] {
  const Kpis = new NBIKpis();
  const defaultKpis: any = [];
  defaultKpis.push({ field: Kpis.NBI_NBI, headerName: "NBI" });
  return defaultKpis;
}

export function getAllKpis(): [{ field: string; headerName: string }] {
  const Kpis = new NBIKpis();
  const allKpis: any = [];
  allKpis.push({ field: Kpis.NBI_NBI, headerName: "NBI" });
  allKpis.push({ field: Kpis.RWA_BY_DATE, headerName: "RWA Stock" });
  return allKpis;
}

export function getAttrsWithColsSelected(columnsSelected: string[]): any[] {
  return getDefaultAttributes().filter(
    (x: any) => columnsSelected.indexOf(x.headerName) > -1
  );
}

export function getKpisWithColsSelected(columnsSelected: string[]): any[] {
  if (columnsSelected && columnsSelected.length > 0) {
    const result = getAllKpis().filter(
      (x: any) => columnsSelected.indexOf(x.headerName) > -1
    );
    if (result && result.length > 0) {
      return result;
    }
    return getDefaultKpis();
  }
  return getDefaultKpis();
}
